import { render, staticRenderFns } from "./CorrectOrderSlideOptions.vue?vue&type=template&id=93cde84a&scoped=true&"
import script from "./CorrectOrderSlideOptions.vue?vue&type=script&lang=js&"
export * from "./CorrectOrderSlideOptions.vue?vue&type=script&lang=js&"
import style0 from "./CorrectOrderSlideOptions.vue?vue&type=style&index=0&id=93cde84a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cde84a",
  null
  
)

export default component.exports